<template>
  <div>
    <li class="title">
      <span>网页title设置：{{ title }}</span>
      <el-button type="primary" size="mini" @click="editSummary(title, 0, 500)"
        >编辑</el-button
      >
    </li>

    <div class="modular">
      <h2>页头编辑</h2>
      <div class="modular_wrap">
        <div class="upload-item">
          <li class="upload-title"><em>*</em>页头背景图</li>
          <div class="upload-img">
            <img
              v-if="advert01.imageUrl"
              :src="$utils.fileUrl(advert01.imageUrl)"
              alt=""
            />
          </div>
          <li class="tips">推荐尺寸：1920*540</li>
          <div class="but">
            <el-button
              size="mini"
              type="primary"
              @click="editAdver(advert01, 1)"
              >更改</el-button
            >
          </div>
        </div>
        <div class="upload-item">
          <li class="upload-title">页头居中文字图</li>
          <div class="upload-img">
            <img
              v-if="advert02.imageUrl"
              :src="$utils.fileUrl(advert02.imageUrl)"
              alt=""
            />
          </div>
          <li class="tips">推荐尺寸：888*110</li>
          <div class="but">
            <el-button
              size="mini"
              type="primary"
              @click="editAdver(advert02, 2)"
              >更改</el-button
            >
            <el-button size="mini" type="danger" @click="delAdver(2)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="modular">
      <h2>banner编辑</h2>
      <div class="modular_wrap">
        <div class="upload-item">
          <li class="upload-title">第一banner位</li>
          <div class="upload-img">
            <img
              v-if="advert03.imageUrl"
              :src="$utils.fileUrl(advert03.imageUrl)"
              alt=""
            />
          </div>
          <li class="tips">推荐尺寸：1200*140</li>
          <div class="but">
            <el-button
              size="mini"
              type="primary"
              @click="editAdver(advert03, 3)"
              >更改</el-button
            >
          </div>
        </div>
      </div>
      <div class="modular_wrap">
        <div
          class="upload-item"
          v-for="(item, index) in banner01"
          :key="item.id"
        >
          <li class="upload-title">{{ !index ? "第二banner位" : "" }}</li>
          <div class="upload-img">
            <img
              v-if="item.imageUrl"
              :src="$utils.fileUrl(item.imageUrl)"
              alt=""
            />
          </div>
          <li class="tips">推荐尺寸：1200*180</li>
          <div class="but">
            <el-button
              size="mini"
              type="primary"
              @click="editAdver(item, 4, banner01)"
              >更改</el-button
            >
            <el-button
              size="mini"
              type="danger"
              v-if="index > 0"
              @click="delBanner(index, banner01)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="modular_wrap">
        <div
          class="upload-item"
          v-for="(item, index) in banner02"
          :key="item.id"
        >
          <li class="upload-title">{{ !index ? "第三banner位" : "" }}</li>
          <div class="upload-img">
            <img
              v-if="item.imageUrl"
              :src="$utils.fileUrl(item.imageUrl)"
              alt=""
            />
          </div>
          <li class="tips">推荐尺寸：1200*180</li>
          <div class="but">
            <el-button
              size="mini"
              type="primary"
              @click="editAdver(item, 4, banner02)"
              >更改</el-button
            >
            <el-button
              size="mini"
              type="danger"
              v-if="index > 0"
              @click="delBanner(index, banner02)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="modular">
      <h2>信夫新闻</h2>
      <div class="modular_wrap">
        <div class="upload-item">
          <div class="but">
            <el-button
              size="mini"
              type="primary"
              @click="$router.push('/operate/pageManage/homeNews')"
              >去编辑</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="modular">
      <h2>活动/承诺图片编辑</h2>
      <div class="modular_wrap">
        <div class="upload-item">
          <li class="upload-title">承诺展示图</li>
          <div class="upload-img">
            <img
              v-if="data.promiseImage"
              :src="$utils.fileUrl(data.promiseImage.imageUrl)"
              alt=""
            />
          </div>
          <li class="tips">推荐尺寸：595*295</li>
          <div class="but">
            <input
              type="file"
              id="promise"
              @change="upload(4, $event, 'promise')"
            />
            <el-button size="mini" type="primary" @click="openFile('promise')"
              >更改</el-button
            >
          </div>
        </div>
        <div class="upload-item">
          <li class="upload-title">活动展示图</li>
          <div class="upload-img">
            <img
              v-if="data.activityImage"
              :src="$utils.fileUrl(data.activityImage.imageUrl)"
              alt=""
            />
          </div>
          <li class="tips">推荐尺寸：595*295</li>
          <div class="but">
            <input
              type="file"
              id="activity"
              @change="upload(4, $event, 'activity')"
            />
            <el-button size="mini" type="primary" @click="openFile('activity')"
              >更改</el-button
            >
          </div>
        </div>
      </div>
    </div> -->

    <!-- 诚信认证公示 -->
    <div class="wide">
      <div class="modular vendors">
        <h2>诚信认证公示slogan编辑</h2>
        <li class="subtitle">
          {{ data.creditCertificateDescribe }}
          <el-button
            type="primary"
            size="mini"
            @click="editSummary(data.creditCertificateDescribe, 9)"
            >编辑</el-button
          >
        </li>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="modular">
      <div class="partner-title">
        <h2>合作伙伴编辑</h2>
        <li>
          {{ data.partnerDescribe }}
          <el-button
            type="primary"
            size="mini"
            @click="editPartnerText(data.partnerDescribe)"
            >编辑</el-button
          >
        </li>
      </div>
      <div class="partner">
        <Draggable
          class="partner-warp"
          item-key="seq"
          :list="partner"
          @change="partnerSort"
        >
          <template #item="{ element }">
            <div class="partner-col">
              <div
                class="partner_warp-item"
                :style="
                  element.imageUrl
                    ? `background-image: url(${$utils.fileUrl(
                        element.imageUrl
                      )})`
                    : ''
                "
              >
                <ul>
                  <li>
                    <el-button
                      type="primary"
                      size="mini"
                      @click.stop="editPartner(element)"
                      >编辑</el-button
                    >
                  </li>
                  <li>
                    <el-button
                      type="danger"
                      size="mini"
                      @click.stop="delPartner(element)"
                      >删除</el-button
                    >
                  </li>
                </ul>
              </div>
            </div>
          </template>
        </Draggable>
        <div class="partner-col" v-if="partner.length < 20">
          <div class="partner_warp-item add" @click="partner_dialog = true">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </div>
      <div class="save-button">
        <el-button type="primary" size="small" @click="setPartner"
          >保存</el-button
        >
      </div>
    </div>

    <!-- 广告 -->
    <el-dialog
      v-model="advert_dialog"
      title="编辑广告"
      width="500px"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          :model="advertForm"
          :rules="advertRules"
          size="mini"
          ref="advertForm"
          label-width="80px"
          label-position="right"
        >
          <el-form-item label="图片：" prop="imageUrl">
            <label
              class="upload-advert"
              for="file"
              :style="
                advertForm.imageUrl
                  ? `background-image: url(${$utils.fileUrl(
                      advertForm.imageUrl
                    )})`
                  : ''
              "
            >
              <i class="el-icon-plus" v-if="!advertForm.imageUrl"></i>
              <input type="file" id="file" @change="upload(5, $event)" />
            </label>
          </el-form-item>
          <el-form-item
            label="链接："
            prop="imageLink"
            v-if="advertForm.pageLocation > 2"
          >
            <el-input
              placeholder="链接"
              v-model="advertForm.imageLink"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="简介：">
            <el-input
              rows="5"
              resize="none"
              type="textarea"
              placeholder="简介"
              maxlength="500"
              show-word-limit
              v-model="advertForm.imageExplain"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="advert_dialog = false" size="mini">取消</el-button>
          <el-button @click="submit_advert" type="primary" size="mini"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 合作伙伴 -->
    <el-dialog
      v-model="partner_dialog"
      width="500px"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="partnerClose"
    >
      <div>
        <el-form
          :model="partnerForm"
          :rules="partnerRules"
          size="mini"
          ref="partnerForm"
          label-width="95px"
          label-position="right"
        >
          <el-form-item label="图片：" prop="imageUrl">
            <label
              class="upload-partner"
              for="partner"
              :style="
                partnerForm.imageUrl
                  ? `background-image: url(${$utils.fileUrl(
                      partnerForm.imageUrl
                    )})`
                  : ''
              "
            >
              <i class="el-icon-plus" v-if="!partnerForm.imageUrl"></i>
              <input type="file" id="partner" @change="upload(4, $event)" />
            </label>
          </el-form-item>

          <el-form-item label="链接：" prop="imageLink">
            <el-input
              placeholder="链接"
              v-model="partnerForm.imageLink"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="partner_dialog = false" size="mini"
            >取消</el-button
          >
          <el-button @click="addPartner" type="primary" size="mini"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
export default {
  components: {
    Draggable,
  },
  data() {
    return {
      data: {},
      title: "",

      loading: false,
      advert_dialog: false,
      partner_dialog: false,

      advertForm: {
        id: "",
        imageUrl: "",
        imageExplain: "",
        imageLink: "",
        pageLocation: null,
      },
      partnerForm: {
        imageUrl: "",
        imageLink: "",
        seq: null,
        id: null,
      },
      partnerRules: {
        imageUrl: [
          { required: true, message: "请选择合作伙伴Logo", trigger: "change" },
        ],
        imageLink: [
          {
            required: false,
            pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
            message: "格式不正确",
            trigger: "blur",
          },
        ],
      },
      partner: [],
      advertRules: {
        imageUrl: [
          { required: true, message: "请选择图片", trigger: "change" },
        ],
        imageLink: [
          {
            required: false,
            pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
            message: "格式不正确",
            trigger: "blur",
          },
        ],
      },
      advert01: {},
      advert02: {},
      advert03: {},
      banner: [],
      banner01: [],
      banner02: [],
    };
  },
  methods: {
    // 获取所有数据
    async getData() {
      try {
        const res = await this.$api.pageManage.getData(1);
        if (res.code === 10200) {
          this.data = res.data;
          this.title = res.data.webTitle.content;

          this.advert01 = res.data.advert01;
          this.advert02 = res.data.advert02;
          this.advert03 = res.data.advert03;

          this.banner01 = res.data.banner01;
          this.banner02 = res.data.banner02;
          this.partner = res.data.partner;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {}
    },
    // 广告更改按钮
    editAdver(data, type, bannerData) {
      this.advertForm.imageUrl = data.imageUrl;
      this.advertForm.imageLink = data.imageLink;
      this.advertForm.imageExplain = data.imageExplain;
      this.advertForm.pageLocation = type;
      this.advert_dialog = true;
      if (bannerData) {
        this.banner = bannerData;
        this.advertForm.id = data.id;
      }
    },
    submit_advert() {
      this.$refs["advertForm"].validate((valid) => {
        if (valid) {
          if (this.advertForm.pageLocation <= 3) {
            const params = {
              imageUrl: this.advertForm.imageUrl,
              imageExplain: this.advertForm.imageExplain,
              imageLink: this.advertForm.imageLink,
              pageLocation: this.advertForm.pageLocation,
              pageType: 1,
            };
            this.set_advert(params);
          } else if (this.advertForm.pageLocation === 4) {
            const params = this.banner.map((item) => {
              if (item.id === this.advertForm.id) {
                item.imageUrl = this.advertForm.imageUrl;
                item.imageExplain = this.advertForm.imageExplain;
                item.imageLink = this.advertForm.imageLink;
              }
              return item;
            });
            this.setBanner(params);
          }
        } else {
          return false;
        }
      });
    },
    // 提交编辑广告
    async set_advert(params) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.pageManage.setAdvert(params);
          this.$loading.done();
          this.loading = false;
          if (res.code === 10200) {
            this.advert_dialog = false;
            this.getData();
            this.$message.success("操作成功！");
          } else {
            this.$message.error(res.msg);
          }
        } catch (err) {
          this.$loading.done();
          this.loading = false;
        }
      }
    },
    // 删除广告
    delAdver(type) {
      this.$confirm("你确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            imageUrl: "",
            imageExplain: "",
            imageLink: "",
            pageType: 1,
            pageLocation: type,
          };
          this.set_advert(params);
        })
        .catch(() => {});
    },

    selectFile(id) {
      const dom = document.getElementById(id);
      dom.click();
    },
    delBanner(index, data) {
      this.$confirm("你确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          data.forEach((item, i) => {
            if (index === i) {
              item.imageUrl = "";
              item.imageLink = "";
              item.imageExplain = "";
            }
          });
          this.setBanner(data);
        })
        .catch(() => {});
    },
    upload(type, e, index) {
      e = e.target || e.srcElement;
      const files = e.files[0];
      if (e.value == "") {
        return;
      }

      let args = files.name.split(".");
      let nameType = args[args.length - 1];
      const fileType = ["jpg", "png", "svg"];

      if (fileType.indexOf(nameType) < 0) {
        this.$message.warning(`不支持上传${nameType}格式的文件`);
        return;
      }

      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        this.$api
          .uploadFile(type, files)
          .then((res) => {
            e.value = "";
            this.$loading.done();
            this.loading = false;
            if (type === 3) {
              this.$message.success("上传成功");
              this.data.banner[index].imageUrl = res;
            } else if (type === 4) {
              if (index === "promise") {
                this.setPromiseActivity(res, 1);
              } else if (index === "activity") {
                this.setPromiseActivity(res, 2);
              } else {
                this.$message.success("上传成功");
                this.partnerForm.imageUrl = res;
              }
            } else if (type === 5) {
              this.$message.success("上传成功");
              this.advertForm.imageUrl = res;
            }
          })
          .catch((err) => {
            e.value = "";
            this.$loading.done();
            this.loading = false;
          });
      }
    },
    async setBanner(params) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          params = JSON.stringify(params);
          const res = await this.$api.pageManage.home.setBanner(params);
          this.$loading.done();
          this.loading = false;
          if (res.code === 10200) {
            this.advert_dialog = false;
            this.getData();
            this.$message.success("保存成功！");
          } else {
            this.$message.error(res.msg);
          }
        } catch (err) {
          this.$loading.done();
          this.loading = false;
        }
      }
    },
    // 编辑概述
    editSummary(content, type, limit = 30) {
      this.$prompt("请输入内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: content,
        inputValidator: (value) => {
          if (!value) return "请输入内容";
          else if (value.length > limit) return `最多输入${limit}个字符`;
          else return true;
        },
      })
        .then(({ value }) => {
          this.setSummary({
            content: value,
            pageType: 1,
            pageLocation: type,
          });
        })
        .catch(() => {});
    },
    // 保存概述
    async setSummary(params) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.pageManage.setSummary(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData();
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },

    openFile(id) {
      const dom = document.getElementById(id);
      dom.click();
    },
    // 保存诚信承诺和活动图片
    async setPromiseActivity(url, type) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            pageType: 1,
            imageUrl: url,
            pageLocation: type,
          };
          const res = await this.$api.pageManage.home.setPromiseActivity(
            params
          );
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData();
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },

    setFormula() {
      const params = {
        type: 2,
        content1: this.data.creditCertificateDescribe,
        content2: this.data.customDescribe,
      };
      this.setProjectCapitalSummary(params);
    },
    partnerClose() {
      this.partnerForm = {
        imageUrl: "",
        imageLink: "",
        seq: null,
      };
    },
    editPartner(data) {
      this.partnerForm = {
        imageUrl: data.imageUrl,
        imageLink: data.imageLink,
        id: data.id,
        seq: data.seq,
      };
      this.partner_dialog = true;
    },
    delPartner(data) {
      if (this.partner.length === 1) {
        this.$message.warning("数据不能全部删除！");
        return;
      }
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.partner.splice(data.seq - 1, 1);
          this.partnerSort();
        })
        .catch(() => {});
    },
    addPartner() {
      this.$refs["partnerForm"].validate((valid) => {
        if (valid) {
          const data = {
            imageUrl: this.partnerForm.imageUrl,
            imageLink: this.partnerForm.imageLink,
            id: this.partnerForm.id,
            seq: !this.partnerForm.seq
              ? this.partner.length + 1
              : this.partnerForm.seq,
          };
          if (!this.partnerForm.seq) {
            this.partner.push(data);
          } else {
            this.partner.splice(this.partnerForm.seq - 1, 1, data);
          }
          this.partner_dialog = false;
        } else {
          return false;
        }
      });
    },
    partnerSort() {
      this.partner.forEach((item, index) => {
        item.seq = index + 1;
      });
    },
    editPartnerText(content) {
      this.$prompt("请输入内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: content,
        inputValidator: (value) => {
          if (!value) return "请输入内容";
          else if (value.length > 30) return `最多输入30个字符`;
          else return true;
        },
      })
        .then(({ value }) => {
          const params = {
            partnerDescribe: value,
            partnerList: this.data.partner,
          };
          this.submitPartner(params);
        })
        .catch(() => {});
    },
    async setPartner() {
      const params = {
        partnerDescribe: this.data.partnerDescribe,
        partnerList: this.data.partner,
      };
      this.submitPartner(params);
    },
    async submitPartner(params) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.pageManage.home.setPartner(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData();
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      this.swiper = new this.Swiper("#head-swiper", {
        effect: "fade",
        autoplay: 5000,
        loop: true,
      });
    });
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 0.875rem;
  margin-bottom: 10px;
  padding: 15px;
  background-color: #ffffff;

  .el-button {
    margin-left: 20px;
  }
}

.wide {
  background-color: #ffffff;
}

.modular {
  padding: 24px;
  margin-bottom: 24px;
  background-color: #ffffff;

  h2 {
    margin-bottom: 20px;
    font-size: 1.125rem;
  }

  .modular_wrap {
    display: flex;

    & + .modular_wrap {
      margin-top: 40px;
    }

    .upload-item {
      width: 180px;

      & + .upload-item {
        margin-left: 60px;
      }

      .upload-title {
        height: 24px;
        line-height: 24px;
        font-size: 0.875rem;

        em {
          color: $--color-danger;
        }
      }

      .tips {
        line-height: 24px;
        font-size: 0.75rem;
        color: $--color-text-secondary;
      }

      .upload-img {
        width: 180px;
        height: 70px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .but {
        display: flex;
        .el-button {
          width: 80px;

          & + .el-button {
            margin-left: auto;
          }
        }

        input[type="file"] {
          display: none;
        }
      }

      &[class*="add"] {
        .upload-img {
          cursor: pointer;
          line-height: 70px;
          text-align: center;
          border: 1px solid $--border-color-base;

          i {
            font-size: 1.5rem;
            color: $--border-color-base;
          }
        }
      }
    }
  }
}

.advertisement {
  width: 100%;
  display: flex;
  min-height: 100px;
  position: relative;
  border: 1px solid $--color-danger;
  img {
    width: 100%;
  }

  .tips {
    top: 40px;
    left: 50px;
    padding: 3px 10px;
    position: absolute;
    font-size: 0.75rem;
    background-color: $--color-warning;
  }

  .el-button {
    top: 40px;
    right: 40px;
    width: 120px;
    position: absolute;
  }
}

.upload-advert {
  width: 100px;
  height: 40px;
  cursor: pointer;
  line-height: 40px;
  text-align: center;
  display: inline-block;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid $--border-color-base;
  input {
    display: none;
  }
}

.upload-partner {
  width: 172px;
  height: 120px;
  cursor: pointer;
  line-height: 120px;
  text-align: center;
  display: inline-block;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid $--border-color-base;
  input {
    display: none;
  }

  i {
    font-size: 1.25rem;
  }
}

.investment_financing {
  display: flex;

  .financing {
    .investment_financing_wrap {
      height: 460px;
      border-right: 1px solid #dbdbdb;
      .financing_wrap-item {
        padding-right: 40px;
      }
    }
  }

  .investment {
    .investment_financing_wrap {
      .financing_wrap-item {
        padding-left: 40px;
      }
    }
  }

  & > div {
    flex: 1;
  }
}

.event {
  padding: 70px 0;
  display: flex;

  & > div {
    flex: 1;
    height: 344px;
    position: relative;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    &:first-child {
      margin-right: 20px;
    }

    .edit-img {
      top: 15px;
      right: 15px;
      width: 150px;
      padding: 10px;
      cursor: pointer;
      position: absolute;
      box-sizing: border-box;
      background-color: rgba(255, 255, 255, 0.8);

      input {
        display: none;
      }

      li {
        &:first-child {
          margin-bottom: 8px;
          .el-button {
            width: 100px;
          }
        }
        span {
          font-size: 0.875rem;
          color: $--color-text-secondary;
        }
      }
    }

    & > button {
      left: 45px;
      bottom: 38px;
      height: 40px;
      border: none;
      padding: 0 20px;
      color: #ffffff;
      position: absolute;
      font-size: 1.125rem;
      border-radius: 20px;
      background-color: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 0px 10px 2px rgba(86, 147, 255, 0.2);
      span {
        vertical-align: middle;
      }
      img {
        width: 24px;
        vertical-align: middle;
      }
    }
  }
}

.formula-button {
  padding: 50px 0;
  text-align: center;

  button {
    width: 365px;
    border: none;
    color: #ffffff;
    font-size: 1.25rem;
    padding: 16px 40px;
    border-radius: 35px;
    background-color: $--color-primary;

    // div {
    //   color: #000;
    //   padding: 0 4px;
    //   background-color: #ffffff;

    //   &:focus-visible {
    //     border: none;
    //     outline: none;
    //   }
    // }

    .el-input {
      input {
        border: none;
      }
    }
  }
}

.partner-title {
  h2 {
    font-size: 1.5rem;
  }

  li {
    line-height: 24px;
    margin-bottom: 40px;
  }
}

.partner {
  width: 100%;
  margin-left: -5px;
  margin-right: -5px;
  .partner-warp {
  }

  .partner-col {
    width: 20%;
    height: 220px;
    padding: 0 5px;
    margin-bottom: 10px;
    display: inline-block;
    box-sizing: border-box;
    .add {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: $--border-radius-base;
      border: 1px solid $--border-color-base;
      i {
        font-size: 2.25rem;
        color: $--color-text-secondary;
      }
    }
  }
  .partner_warp-item {
    width: 100%;
    height: 220px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    background-size: cover;
    background-color: #ffffff;
    background-position: center;
    background-repeat: no-repeat;
    transition: $--all-transition;
    border-radius: $--border-radius-base;

    ul {
      right: 10px;
      bottom: 10px;
      position: absolute;

      li {
        &:first-child {
          margin-bottom: 10px;
        }
      }
    }
  }
  & > img {
    width: 100%;
  }
}

.save-button {
  text-align: center;
  .el-button {
    width: 120px;
  }
}
</style>